import moment from 'moment';

export const getDateRange = () => {
    return [
        { 'label': 'Today', value: [moment().startOf('day'), moment().endOf('day')] },
        { 'label': 'Yesterday', value: [moment().subtract(1, 'days').startOf('day'), moment().endOf('day')] },
        { 'label': 'Last 7 Days', value: [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')] },
        { 'label': 'Last 45 Days', value: [moment().subtract(45, 'days').startOf('day'), moment().endOf('day')] },
        { 'label': 'Last 6 months', value: [moment().subtract(180, 'days'), moment().endOf('day')] },
        { 'label': 'Last 1 Year', value: [moment().subtract(365, 'days').startOf('day'), moment().endOf('day')] },
        { 'label': 'Last 3 Years', value: [moment().subtract(365 * 3, 'days').startOf('day'), moment().endOf('day')] },
        { 'label': 'Last 5 Years', value: [moment().subtract(365 * 5, 'days').startOf('day'), moment().endOf('day')] },
        { 'label': 'Last 10 Years', value: [moment().subtract(365 * 10, 'days').startOf('day'), moment().endOf('day')] },
    ]
}

export const smallDateRange = () => {
    return [
        { 'label': 'Last 6 months', value: [moment().subtract(180, 'days'), moment().endOf('day')] },
        { 'label': 'Last 1 Year', value: [moment().subtract(365, 'days').startOf('day'), moment().endOf('day')] },
        { 'label': 'Last 3 Years', value: [moment().subtract(365 * 3, 'days').startOf('day'), moment().endOf('day')] },
        { 'label': 'Last 5 Years', value: [moment().subtract(365 * 5, 'days').startOf('day'), moment().endOf('day')] },
        { 'label': 'Last 7 Years', value: [moment().subtract(365 * 7, 'days').startOf('day'), moment().endOf('day')] },
    ]
}